"use client";

import { ArrowRight, Film } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function HowWeWork() {
  const image = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const content = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const workshops = [{
    date: "UAE",
    title: "UAE Registered Company",
    duration: "PRO"
  }, {
    date: "EXP",
    title: "Industry Experience",
    duration: "PRO"
  }, {
    date: "RES",
    title: "Proven Results",
    duration: "PRO"
  }];
  return <section data-section-id="2424" id="how-we-work" className="bg-background text-foreground relative overflow-hidden py-24 md:py-40 px-6 md:px-12 lg:px-20">
      {}
      <div className="hidden lg:flex absolute right-0 top-0 bottom-0 w-10 flex-col items-center justify-around border-l border-r border-border/40 bg-card/30 z-0">
        {Array.from({
        length: 18
      }).map((_, i) => <div data-index={i} key={i} className="w-3 h-5 rounded-md bg-background/80 border border-border/50" />)}
      </div>

      <div className="relative z-10 max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-5 gap-12 lg:gap-16 items-center">
          {}
          <div ref={image.ref} className={`lg:col-span-3 transition-all duration-1000 ease-out ${image.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <div className="relative rounded-2xl overflow-hidden shadow-xl">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1704709/img/influencer_marketing_strategy.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1704709/img/influencer_marketing_strategy.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1704709/img/influencer_marketing_strategy.png-wvc-sizes" alt="Strategic influencer marketing campaign dashboard" loading="lazy" decoding="async" className="w-full h-[420px] md:h-[560px] lg:h-[640px] object-cover" />
              {}
              <div className="absolute inset-0 pointer-events-none" style={{
              background: "radial-gradient(ellipse at 80% 30%, hsla(142, 76%, 45%, 0.15) 0%, transparent 60%), radial-gradient(ellipse at 10% 90%, hsla(220, 15%, 4%, 0.18) 0%, transparent 55%)"
            }} />
              {}
              <div className="absolute bottom-5 left-5 md:bottom-6 md:left-6">
                <span className="font-mono text-[11px] md:text-xs tracking-[0.2em] uppercase text-foreground/90 bg-background/60 backdrop-blur-sm px-3 py-2 rounded-md border border-foreground/10">
                  Agency · Strategy · Growth
                </span>
              </div>
            </div>
          </div>

          {}
          <div ref={content.ref} className={`lg:col-span-2 transition-all duration-1000 ease-out delay-150 ${content.isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            {}
            <div className="flex items-center gap-3 mb-8">
              <Film className="w-4 h-4 text-primary" strokeWidth={1.5} />
              <span className="font-mono text-xs tracking-[0.28em] uppercase text-primary">
                Why Choose Us
              </span>
            </div>

            {}
            <h2 className="font-default font-bold text-5xl md:text-6xl lg:text-7xl leading-[1.02] tracking-tight text-foreground mb-10">
              Built for
              <br />
              measurable
              <br />
              <span className="italic font-light text-primary/80">
                impact.
              </span>
            </h2>

            {}
            <p className="font-default text-[17px] leading-relaxed text-foreground/80 mb-12 max-w-lg">
              We bridge the gap between brands and creators. Our agency provides 
              the infrastructure, strategy, and direct access needed to scale 
              your presence across YouTube, TikTok, and Instagram effectively.
            </p>

            {}
            <div className="mb-12">
              <div className="flex items-center justify-between mb-5">
                <span className="font-mono text-xs tracking-[0.24em] uppercase text-muted-foreground">
                  Core Advantages
                </span>
                <span className="font-mono text-xs tracking-[0.18em] uppercase text-muted-foreground">UAE REGISTERED • 2026</span>
              </div>

              <ul className="border-t border-border/60">
                {workshops.map((w, i) => <li data-index={i} key={w.title} className="flex flex-col sm:flex-row sm:items-center justify-between gap-3 sm:gap-4 py-5 border-b border-border/60">
                    <div className="flex items-center gap-5 min-w-0 flex-1">
                      <span className="font-mono text-xs tracking-[0.18em] text-primary shrink-0">
                        {w.date}
                      </span>
                      <span className="font-default text-base md:text-lg text-foreground leading-snug">
                        {w.title}
                      </span>
                    </div>
                    <Button variant="secondary" size="sm" className="rounded-md bg-card text-foreground hover:bg-accent font-mono text-[10px] tracking-[0.22em] uppercase px-4 self-start sm:self-auto" asChild>
                      <Link to="/HomePage">Details</Link>
                    </Button>
                  </li>)}
              </ul>
            </div>

            {}
            <Button size="lg" className="rounded-lg bg-primary text-primary-foreground hover:bg-primary/90 font-mono text-xs tracking-[0.22em] uppercase px-7 h-12 shadow-lg" asChild>
              <Link to="#contact-us">
                Contact Our Team
                <ArrowRight className="w-4 h-4 ml-1" strokeWidth={1.75} />
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}